<script>
import ShortVideo from "@/components/training/scene/ShortVideo.vue";
import LiveData from "@/components/training/scene/LiveData.vue";
import IndexData from "@/components/training/scene/IndexData.vue";
import KefuData from "@/components/training/scene/KefuData.vue";
export default {
    data() {
        return {

            navList: [
                "短视频数据","直播数据", "主页数据","客服数据"
            ],
            activeNavIndex: 0,

        }
    },
    components: {
        ShortVideo,
        LiveData,
        IndexData,
        KefuData
    },
    methods: {
        changeIndex(index) {
            this.activeNavIndex = index;
        }
    }
}
</script>

<template>
    <div class="scene-main">
        <div class="scene-content">
            <div class="nav-tabs-wrapper">
                <div class="nav-item" :class="activeNavIndex === index ? 'active': ''" v-for="(item,index) in navList" :key="index" @click="changeIndex(index)">
                    {{item}}
                </div>
            </div>
            <div class="data-main">
                <short-video v-if="activeNavIndex === 0" />
                <live-data v-if="activeNavIndex === 1" />
                <index-data v-if="activeNavIndex === 2" />
                <kefuData v-if="activeNavIndex === 3" />
            </div>

        </div>
    </div>

</template>

<style scoped lang="scss">
.scene-main {
    &, & * {
        box-sizing: border-box;
    }
    width: 100%;
    height: 100%;
    .scene-content {
        .data-main {
            height: calc(100% - 64px);
            width: 100%;
        }
        &:deep(.el-scrollbar) {
            .el-scrollbar__wrap {
                overflow-x: hidden;
            }
        }
        &:deep(.nav-wrap-list) {
            background: #fff;
            width: 100%;
            border-radius: 12px;
            margin: 16px 0;
            padding: 16px 24px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }
        width: 100%;
        height: 100%;
        padding: 16px 24px 0 24px;
        .nav-tabs-wrapper {
            width: 100%;
            height: 64px;
            background: #fff;
            border-radius: 12px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            padding: 0 24px;
            .nav-item {
                cursor: pointer;
                height: 100%;
                font-size: 16px;
                margin-right: 40px;
                display: flex;
                align-items: center;
                color: #64666b;
                &.active {
                    font-weight: 600;
                    border-bottom: 4px solid #2B55E5;
                    color: #323335;

                }
            }
            .day-tabs {
                width: 110px;
                height: 38px;
                border-radius: 5px;
                border: 1px solid #D9DADC;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #50525A;
                margin-right: 10px;
                &.active {
                    color: #2B55E5;
                    border-color: #2B55E5;
                }

            }

        }
    }
}
</style>
